import { render, staticRenderFns } from "./o-list-news-v2.vue?vue&type=template&id=4723427d&scoped=true"
import script from "./o-list-news-v2.vue?vue&type=script&lang=js"
export * from "./o-list-news-v2.vue?vue&type=script&lang=js"
import style0 from "./o-list-news-v2.vue?vue&type=style&index=0&id=4723427d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4723427d",
  null
  
)

export default component.exports